module.exports = __webpack_public_path__ + "img/box-lan.468da758.png";